module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GU-83b24be668a6634d403400d9e7f731a2.png";